export default __webpack_public_path__ + "static/media/background-partnership-red.e9402a5e.png";